import PageForm from 'components/pageForm/PageForm.js';
import BodyFicheVivier from './components/content/body.fiche.vivier.js';

const FicheVivier = () => (
  <PageForm>
    <BodyFicheVivier />
  </PageForm>
);

export default FicheVivier;
